document.addEventListener('DOMContentLoaded', function () {
    // Get popup elements
    const popup = document.getElementById('jotformPopup');
    const iframe = document.getElementById('jotformFrame');
    const closeBtn = popup.querySelector('.jotform-popup__close');
    const overlay = popup.querySelector('.jotform-popup__overlay');

    // Function to open modal
    function openModal(url) {
        iframe.src = url;
        popup.style.display = 'block';
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    }

    // Function to close modal
    function closeModal() {
        popup.style.display = 'none';
        iframe.src = '';
        document.body.style.overflow = ''; // Restore scrolling
    }

    // Add click event listeners to all elements with jotform-trigger class
    document.querySelectorAll('.jotform-trigger').forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            const url = this.getAttribute('href');
            if (url) {
                openModal(url);
            }
        });
    });

    // Close modal when clicking close button or overlay
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    // Close modal when pressing ESC key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.style.display === 'block') {
            closeModal();
        }
    });
}); 